/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_Resource_Types_DeskInputs */

const en_admin_resources_resource_types_desk = /** @type {(inputs: Admin_Resources_Resource_Types_DeskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desk`)
};

const de_admin_resources_resource_types_desk = /** @type {(inputs: Admin_Resources_Resource_Types_DeskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schreibtisch`)
};

const es_admin_resources_resource_types_desk = /** @type {(inputs: Admin_Resources_Resource_Types_DeskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escritorio`)
};

const fr_admin_resources_resource_types_desk = /** @type {(inputs: Admin_Resources_Resource_Types_DeskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bureau`)
};

/** @type {(inputs: Admin_Resources_Resource_Types_DeskInputs) => LocalizedString} */
const it_admin_resources_resource_types_desk = en_admin_resources_resource_types_desk;

/** @type {(inputs: Admin_Resources_Resource_Types_DeskInputs) => LocalizedString} */
const pt_br2_admin_resources_resource_types_desk = en_admin_resources_resource_types_desk;

/** @type {(inputs: Admin_Resources_Resource_Types_DeskInputs) => LocalizedString} */
const pl_admin_resources_resource_types_desk = en_admin_resources_resource_types_desk;

/** @type {(inputs: Admin_Resources_Resource_Types_DeskInputs) => LocalizedString} */
const hu_admin_resources_resource_types_desk = en_admin_resources_resource_types_desk;

/** @type {(inputs: Admin_Resources_Resource_Types_DeskInputs) => LocalizedString} */
const ro_admin_resources_resource_types_desk = en_admin_resources_resource_types_desk;

/**
* | output |
* | --- |
* | "Desk" |
*
* @param {Admin_Resources_Resource_Types_DeskInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_resource_types_desk = /** @type {((inputs?: Admin_Resources_Resource_Types_DeskInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_Resource_Types_DeskInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_resource_types_desk(inputs)
	if (locale === "de") return de_admin_resources_resource_types_desk(inputs)
	if (locale === "es") return es_admin_resources_resource_types_desk(inputs)
	if (locale === "fr") return fr_admin_resources_resource_types_desk(inputs)
	if (locale === "it") return it_admin_resources_resource_types_desk(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_resource_types_desk(inputs)
	if (locale === "pl") return pl_admin_resources_resource_types_desk(inputs)
	if (locale === "hu") return hu_admin_resources_resource_types_desk(inputs)
	return ro_admin_resources_resource_types_desk(inputs)
});
export { admin_resources_resource_types_desk as "admin.resources.resource_types.desk" }